export default "__VITE_ASSET__CmLvQS4Z__"